import { APIHelper } from '@archistarai/auth-frontend';
import Vue from 'vue';

export default {
  state: {
    users: [],
    currentEditUser: null
  },
  getters: {
    get: (state) => (guid) => {
      return state.users.find((u) => u.guid === guid);
    },
    getSalesRep(state) {
      return state.users.filter((u) => u.role === 'sales').sort((a, b) => a.name.localeCompare(b.name));
    }
  },
  mutations: {
    ADD_TO_USERS(state, user) {
      let index = state.users.findIndex((u) => u.guid === user.guid);
      if (index < 0) {
        state.users.push(user);
      } else {
        Vue.set(state.users, index, user);
      }
    },
    REMOVE_FROM_USERS(state, userGuid) {
      let index = state.users.findIndex((u) => u.guid === userGuid);
      if (index >= 0) {
        state.users.splice(index, 1);
      }
    },
    SET_CURRENT_EDIT_USER(state, user) {
      state.currentEditUser = user;
    }
  },
  actions: {
    async getUser({ commit, getters }, guid) {
      if (getters.get(guid)) {
        // if cached in state return
        return getters.get(guid);
      }
      try {
        const { data } = await APIHelper.AdminAPI.get(`/users/${guid}`);
        commit('ADD_TO_USERS', data.data);
      } catch (e) {
        throw e;
      }
    },
    async addSystemUser(_, user) {
      await APIHelper.AdminAPI.post('/users', {
        scope: 'system',
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        role_id: user.role_id,
        send_verify_email: user.send_verify_email ? 1 : 0
      });
      return user;
    },
    async putUser({ commit }, user) {
      await APIHelper.AdminAPI.put(`/users/${user.guid}`, {
        first_name: user.first_name,
        last_name: user.last_name,
        mobile: user.mobile,
        organisation: user.organisation,
        profession: user.profession,
        marketing_tags: user.marketingTags,
        billing_country: user.billing_country,
        currency_code: user.currency_code,
        has_cordell_account: user.has_cordell_account ?? 0,
        has_rp_data_account: user.has_rp_data_account ?? 0,
        has_nearmap_account: user.has_nearmap_account ?? 0,
        has_pricefinder_account: user.has_pricefinder_account ?? 0,
        has_bci_account: user.has_bci_account ?? 0
      });
      commit('ADD_TO_USERS', user);
      return user;
    },
    async deleteUserFromCompany({ commit }, { userGuid, companyGuid }) {
      await APIHelper.AdminAPI.delete(`/users/${userGuid}/companies/${companyGuid}`);
      commit('REMOVE_FROM_USERS', userGuid);
    },
    async userResendVerificationEmail({ _commit }, userGuid) {
      await APIHelper.AdminAPI.put(`/users/${userGuid}/resend-verify-email`);
    },
    async getSalesUsers({ commit }) {
      try {
        const {
          data: { data }
        } = await APIHelper.AdminAPI.get('/users?scope=allSales');
        data.forEach((u) => {
          u.guid = u['user_guid'];
          u.role = 'sales';
          commit('ADD_TO_USERS', u);
        });
      } catch (e) {
        throw e;
      }
    }
  }
};
